export default __webpack_public_path__ + "a4ec58644334ab12928faf3a0c3c5196.svg";